/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type ShelfPart } from '@/types/legacy';
import { useEffect } from 'react';
import { useLocalCart } from '@/features/cart/context/CartContext';

type SyncLocalCart = {
  part: ShelfPart;
  acesEnabled: boolean;
  uniqueId: string;
};

export const useSyncLocalCart = ({ part, acesEnabled, uniqueId }: SyncLocalCart) => {
  const localCart = useLocalCart();

  useEffect(() => {
    if (!acesEnabled) {
      return;
    }
    const skuNumberStr = part.skuNumber.toString() || '';
    if (part.itemPresentInCart && localCart.isEmpty && !localCart.isAnyItemBeingAdded) {
      if (!localCart.isLocallyAdded(skuNumberStr, uniqueId)) {
        localCart.addItem(skuNumberStr, uniqueId);
      }
    }
  }, [part, localCart, uniqueId, acesEnabled]);
};
